import { render, staticRenderFns } from "./sapInventory.vue?vue&type=template&id=83f2fc24"
import script from "./sapInventory.vue?vue&type=script&lang=js"
export * from "./sapInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports